import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import { Controller, useForm } from 'react-hook-form';
import CreatableSelect from 'react-select/creatable';
import FormTooltip from 'components/Inputs/FormTooltip';
import DefaultModal from 'components/Modal/DefaultModal';
import { toast } from 'react-toastify';
import ReactButton from 'components/Buttons/ReactButton';
import { useSelector } from 'react-redux';
import IgnoredWordsService from '../../../service';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
const AddWordsModal = ({
  isModalOpen,
  onModalToggle,
  wordsListId,
  refetch,
  validateWords,
  errorFormMessage,
  ...props
}) => {
  const { control, handleSubmit, errors, reset } = useForm({
    defaultValues: {
      words: []
    }
  });
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const [loading, setLoading] = React.useState(false);

  const onSubmit = async (data) => {
    if (!data.words || data.words.length === 0) {
      return;
    }

    setLoading(true);
    try {
      const response = await IgnoredWordsService.getById(wordsListId);
      const currentWords = (
        response.data.data?.words ||
        response.data?.words ||
        []
      ).map((word) => word.original || word);

      const newWords = data.words
        .map((item) => item.value)
        .filter((word) => !currentWords.includes(word));

      if (newWords.length === 0) {
        toast.info('Palavra(s) já existente(s) na lista.');
        onModalToggle(false);
        return;
      }

      const updatedWords = [...currentWords, ...newWords].map((word) => ({
        original: word,
        sanitized: null
      }));

      await IgnoredWordsService.update(wordsListId, {
        ...response.data.data,
        words: updatedWords
      });

      toast.success('Palavra(s) adicionada(s) com sucesso!');
      refetch();
      onModalToggle(false);
      reset();
    } catch (error) {
      toast.error(
        `Erro ao adicionar palavras: ${
          error.response?.data?.message || 'Erro desconhecido'
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Adicionar Palavras Ignoradas"
      showCloseButton={false}
      modalContainerClasses="modal-md"
      centered={true}
      {...props}
      footer={
        <>
          <Button
            color="secondary"
            onClick={() => {
              onModalToggle(false);
              reset();
            }}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={handleSubmit(onSubmit)}
            disabled={loading}
          >
            {loading ? 'Adicionando...' : 'Adicionar'}
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-4">
          <Col sm="12" className="tour3-dt">
            <Row className="mb-3">
              <Col sm="12">
                <label className="form-control-label">
                  Palavras *{' '}
                  <FormTooltip text="Digite as palavras que deseja ignorar e pressione Enter. Elas serão adicionadas à lista, impedindo que novas conversas sejam abertas para o canal associado após o encerramento da conversa." />
                </label>
                <Controller
                  render={(props) => (
                    <CreatableSelect
                      isMulti
                      isClearable={true}
                      options={[]}
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value);
                      }}
                      placeholder="Digite as palavras que deseja ignorar e pressione Enter"
                      labelName="label"
                      valueName="value"
                      formatCreateLabel={(inputValue) =>
                        `Adicionar "${inputValue}"`
                      }
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null
                      }}
                    />
                  )}
                  control={control}
                  name="words"
                  rules={{
                    required: 'Pelo menos uma palavra é obrigatória!',
                    validate: validateWords
                  }}
                  defaultValue={[]}
                />
                {errors.words && errorFormMessage(errors.words.message)}
              </Col>
            </Row>
            <Row className="mt-4">
              <Col className="text-end">
                <Button
                  style={buttonStyle(systemConfiguration.primary_color)}
                  onClick={handleSubmit(onSubmit)}
                  disabled={loading}
                  className="btn-primary"
                >
                  {loading ? 'Adicionando...' : 'Adicionar'}
                </Button>
                <ReactButton
                  btnColor="cancelation"
                  onClick={() => {
                    onModalToggle(false);
                    reset();
                  }}
                  disabled={loading}
                  className="mr-2"
                >
                  Cancelar
                </ReactButton>
              </Col>
            </Row>
          </Col>
        </Row>
      </form>
    </DefaultModal>
  );
};

export default AddWordsModal;
